import { Container, Row, Col } from "react-bootstrap";
import github from "../assets/img/github.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} sm={6}>
            <span className="footer-brand">YoYoGavri</span>
            <p>Software Engineer</p>
          </Col>
          <Col xs={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              {/* eslint-disable-next-line */}
              <a target="_blank" href="https://github.com/YoYoGavri" aria-label="GitHub">
                <img src={github} alt="GitHub" width={'26px'} height={'26px'} />
              </a>
            </div>
            <p>Copyright {new Date().getFullYear()} YoYoGavri. All Rights Reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
